module.exports = __webpack_public_path__ + "static/media/SocketIOIcon.288caf89.png";